import { ThemeOptions } from '@mui/material/styles';

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: 'rgba(33,93,176,0.85)',
      light: '#215db0',
      dark: 'rgba(33,93,176,0.5)',
      contrastText: '#f6f7f9',
    },
    secondary: {
      main: '#238551',
      contrastText: '#f6f7f9',
    },
    background: {
      default: '#f6f7f9',
    },
    text: {
      primary: 'rgba(28,33,39,1)',
      secondary: 'rgba(28,33,39,0.7)',
      disabled: 'rgba(28,33,39,0.4)'
    },
  },
  typography: {
    h2: {
      fontSize: '3.8rem',
    },
    h5: {
      fontWeight: 100,
    },
    fontSize: 10,
    fontWeightLight: 100,
    fontWeightRegular: 100,
    fontWeightMedium: 100,
    fontWeightBold: 400,
    htmlFontSize: 14,
  },
};